import apiService from '@/services/api.service'
import store from '@/store'

export default {

    async getMyClaims() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'status/getMyClaims',
                params: {},
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty my claims!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getStatus(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'status/getStatus',
                params: params,
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty status!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

}
